import React, { useEffect } from 'react';
import Const from '../../../config/const';
import { useNotification } from '../../firebase_messaging_provider';

function AdvisorEnded({ voipChatState }) {
  const { notification, clearNotification } = useNotification();

  if (voipChatState === Const.voipChatStates.endedConversation) return <div />;
  useEffect(() => {
    if (notification && notification.ntype === 'advisor_ended') {
      // chatData[chatType].hangupAction();
      // showGeneralPopup(t('advisor_ended.was_ended', { callType: chatData[chatType].type }), null);
      clearNotification();
    }
    return () => {};
  }, [notification]);
  return <div />;
}

export default AdvisorEnded;
